"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
function deferPromise() {
    var resolve;
    var reject;
    return {
        promise: new Promise(function (internalResolve, internalReject) {
            resolve = internalResolve;
            reject = internalReject;
        }),
        resolve: resolve,
        reject: reject,
    };
}
exports.deferPromise = deferPromise;
function clone(o) {
    return Object.assign(Object.create(Object.getPrototypeOf(o)), o);
}
exports.clone = clone;
__export(require("./queryActionType"));
__export(require("./queryParam"));
